import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdMetadataFormImportResult } from './types';
import { invalidateRegEdBrokerDealerSchema } from './useRegEdBrokerDealerSchemaQuery';
import { invalidateRegEdMetadataSchema } from './useRegEdMetadataSchemaQuery';

/**
 * Destructive replace of a broker-dealer's schema — broker-dealer-scoped (cross-tenant), NOT
 * per-account, hence the system-level admin route with no impersonation.
 */
export const useRegEdMetadataSchemaImportMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IRegEdMetadataFormImportResult, variables: { brokerDealerId: string; file: File }) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ brokerDealerId, file }: { brokerDealerId: string; file: File }) => {
			const formData = new FormData();
			formData.append('file', file);
			return userSession.webServiceHelper.callAsync<IRegEdMetadataFormImportResult>(
				`admin/compliance/regEd/brokerDealers/${encodeURIComponent(brokerDealerId)}/metadataSchema/import`,
				'POST',
				formData
			);
		},
		onError,
		onSuccess: (result, variables) => {
			invalidateRegEdMetadataSchema();
			invalidateRegEdBrokerDealerSchema(variables.brokerDealerId);
			onSuccess?.(result, variables);
		},
	});
};
